/*
 * Copyright (C) 2018 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Service module for general purpose utilities.
 */
(function () {
  angular.module('services.util', []).factory('UtilService', factory);

  factory.$inject = ['$anchorScroll', '$location'];

  /**
   * Builds and returns the UtilService object.
   *
   * @returns {object} - the UtilService object
   */
  function factory($anchorScroll, $location) {
    return {
      getArray: getArray,
      getBoolean: getBoolean,
      getObject: getObject,
      getString: getString,
      extractQueryParams: extractQueryParams,
      isPlainObject: isPlainObject,
      isSet: isSet,
      scrollHome: scrollHome,
      scrollToElement: scrollToElement
    };

    /**
     * Returns the array represented by a value.
     *
     * @param {*[] | function():*[]} value - the array or a function returning the array.
     * @returns {*[]} the value itself if the value is an array, or the result of calling the function if the
     * value is a function.
     */
    function getArray(value) {
      var result = _.isFunction(value) ? value() : value;
      if (isSet(result) && !_.isArray(result)) {
        throw new Error('Expected an array but got ' + typeof result);
      }
      return result;
    }

    /**
     * Returns the boolean represented by a value.
     *
     * @param {boolean | function():boolean} value - the boolean or a function returning the boolean.
     * @returns {boolean} the value itself if the value is a boolean, or the result of calling the function if the value
     * is a function.
     */
    function getBoolean(value) {
      var result = _.isFunction(value) ? value() : value;
      if (isSet(result) && !_.isBoolean(result)) {
        throw new Error('Expected a boolean but got ' + typeof result);
      }
      return result;
    }

    /**
     * Returns the object represented by a value.
     *
     * @param {object | function():object} value - the object or a function returning the object.
     * @returns {object} the value itself if the value is an object, or the result of calling the function if the value
     * is a function.
     */
    function getObject(value) {
      var result = _.isFunction(value) ? value() : value;
      if (isSet(result) && !isPlainObject(result)) {
        throw new Error('Expected an object but got ' + typeof result);
      }
      return result;
    }

    /**
     * Returns the string represented by a value.
     *
     * @param {string | function():string} value - the string or a function returning the string.
     * @returns {string} the value itself if the value is a string, or the result of calling the function if the value
     * is a function.
     */
    function getString(value) {
      var result = _.isFunction(value) ? value() : value;
      if (isSet(result) && !_.isString(result)) {
        throw new Error('Expected a string but got ' + typeof result);
      }
      return result;
    }

    /**
     * Determines whether a value is an object, but not an array or function.
     * NOTE: If we ever switch to lodash we can replace this with _.isPlainObject
     *
     * @param {*} value - the value to be tested.
     * @returns {boolean} - true if the value is a plain object, false otherwise.
     */
    function isPlainObject(value) {
      return _.isObject(value) && !_.isArray(value) && !_.isFunction(value);
    }

    /**
     * Determines whether a value is set to something other than null or undefined.
     * NOTE: If we ever switch to lodash we can replace this with !_.isNil
     *
     * @param {*} value - the value to be tested.
     * @returns {boolean} - true if the value is set, false otherwise.
     */
    function isSet(value) {
      return value !== null && value !== undefined;
    }

    /**
     * Scrolls to the home position of the app.
     */
    function scrollHome() {
      scrollToElement('main-body');
    }

    /**
     * Scrolls to the location of the specified element id.
     *
     * @param {String} id - the HTML id of the element to be scrolled into view
     */
    function scrollToElement(id) {
      $location.hash(id);
      $anchorScroll();
    }

    /**
     * Aggregates the query params from current location
     *
     * @returns {Object} - parsed query params
     */
    function extractQueryParams() {
      const params = {};
      if (window.location.search.split('?').length > 1) {
        const queryParams = window.location.search.split('?')[1].split('&');
        queryParams.forEach((param) => {
          const key = param.split('=')[0];
          params[key] = decodeURIComponent(param.split('=')[1]);
        });
      }

      return params;
    }
  }
})();
